const overflow = 'overflow';
export const aliasOverflow = {
    overflow
};

//# sourceMappingURL=aliasOverflow.js.map